import { useMutation } from 'react-query';

import { renameVersion as mutationFn } from 'api/endPoints/renameVersion';

export const useMutationRenameVersion = () => {
    return useMutation<unknown, QueryError, IRenameVersion>({ mutationFn: (params) => mutationFn(params) });
};

interface IRenameVersion {
    metaDataid: number;
    versionName: string;
}
